import { EMPTY_STRING } from '../../helpers/TxpConstants';
import convertDateTimeToString from './convertDateTimeToString';
import ActivityType from '../../schema/innerSchema/ActivityType';
import BusStopData from '../../schema/viewSchema/BusStopData';
import Place from '../../schema/innerSchema/Place';
import RentalCarReservation from '../../schema/RentalCarReservation';
import TxpStrings from '../../schema/configSchema/TxpStrings';
import TxpDateTimeCallbacks from 'txp-data/lib/schema/configSchema/TxpDateTimeCallbacks';

/**
 * Extracts the rental car specific data needed for displaying the bus stop
 */
export default function populateRentalCarBusStopData(
    rentalCarEntity: RentalCarReservation,
    activityType: ActivityType,
    rentalCompanyPlace: Place,
    txpStrings: TxpStrings,
    icon: string,
    txpDateTimeCallbacks?: TxpDateTimeCallbacks
): BusStopData {
    let collapsedText: string;
    let busStopLabel: string;
    let ariaBusStopText: string;
    let busStopText: string = rentalCompanyPlace ? rentalCompanyPlace.name : null;

    if (activityType == ActivityType.RentalCarPickup) {
        busStopLabel = txpStrings.formatters.format(txpStrings.strings.pickUpText, EMPTY_STRING);
        collapsedText = convertDateTimeToString(
            rentalCarEntity.pickupTime,
            false /*isAccessible*/,
            txpStrings.formatters,
            txpDateTimeCallbacks
        );
        ariaBusStopText = convertDateTimeToString(
            rentalCarEntity.pickupTime,
            true /*isAccessible*/,
            txpStrings.formatters,
            txpDateTimeCallbacks
        );
    } else if (activityType == ActivityType.RentalCarDropOff) {
        busStopLabel = txpStrings.formatters.format(txpStrings.strings.dropOffText, EMPTY_STRING);
        collapsedText = convertDateTimeToString(
            rentalCarEntity.dropoffTime,
            false /*isAccessible*/,
            txpStrings.formatters,
            txpDateTimeCallbacks
        );
        ariaBusStopText = convertDateTimeToString(
            rentalCarEntity.dropoffTime,
            true /*isAccessible*/,
            txpStrings.formatters,
            txpDateTimeCallbacks
        );
    } else {
        return null;
    }

    return {
        busStopLabel: busStopLabel,
        busStopText: busStopText,
        collapsedText: collapsedText,
        ariaBusStopText: ariaBusStopText,
        icon: icon,
    } as BusStopData;
}
